import * as axiosHelper from "../api_helper";
import qs from "qs";

export const getWallets = async () => {
  const data = await axiosHelper.get("/wallets");
  if (data.isError) {
    throw new Error(data.isError);
  }
  return data?.result;
};

export const addWithdraw = async (values) => {
  const data = await axiosHelper.post("mmtransactions/withdraw", values);
  return data;
};

export async function getWithdrawals(params){
  const result = await axiosHelper.get(`transactions/withdraw?${qs.stringify(params)}`);
  if (result.isSuccess === false){
    throw Error("Error while fetching data");
  }
  return result;
}
